import React from "react";
import { motion } from "framer-motion";
import XboxSeriesS from "../../../images/Consoles/Xbox Series S/series-S-title.webp";
import XboxSeriesX from "../../../images/Consoles/Xbox Series X/series-X-title.webp";
import PSBluRay from "../../../images/Consoles/PS5 Blu-Ray/ps5-bluray-title.webp";
import PSSlimBluRay from "../../../images/Consoles/PS5 Slim Blu-Ray/ps5-slim-bluray-title.webp";
import PS4Pro from "../../../images/Consoles/PS4 Pro/ps4-pro-title.webp";
import MetaQuest from "../../../images/Consoles/Meta Quest 3/quest3-title.webp";

const consoles = [
    {
        id: 1,
        name: "Xbox Series S",
        image: XboxSeriesS,
        controllers: '2 геймпади',
        subscription: "Game Pass Ultimate",
    },
    {
        id: 2,
        name: "PlayStation 5 Blu-Ray",
        image: PSBluRay,
        controllers: '2 геймпади',
        subscription: "PS Plus + EA Play",
    },
    {
        id: 3,
        name: "PlayStation 4 Pro",
        image: PS4Pro,
        controllers: '2 геймпади',
        subscription: "PS Plus + EA Play",
    },
    {
        id: 4,
        name: "Xbox Series X",
        image: XboxSeriesX,
        controllers: '2 геймпади',
        subscription: "Game Pass Ultimate",
    },
    {
        id: 5,
        name: "PlayStation 5 Slim",
        image: PSSlimBluRay,
        controllers: '2 геймпади',
        subscription: "PS Plus",
    },
    {
        id: 6,
        name: "Meta Quest 3 512GB",
        image: MetaQuest,
        controllers: 'Додаткова батарея',
        subscription: "50+ ігор",
    },
    
];

const Products = ({ selectConsole }) => {
    return (
        <motion.div
            initial={{ opacity: 0, y: 200 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            viewport={{ once: true }}
            className="p-6 bg-blue-500 text-white rounded-lg shadow-lg"
        >
            <div className="container products-container">
                <h1 id="section1" className="products-container-h1">
                    Оберіть свій <span style={{ color: "red" }}>комплект</span>
                </h1>
                <div className="card-container">
                    {consoles.map((product) => (
                        <div key={product.id} className="card">
                            <img  src={product.image} alt={product.name} />
                            <h2>{product.name}</h2>
                            <p style={{ color: "red" }}>{product.controllers}</p>
                            <p>{product.subscription}</p>
                            <button onClick={() => selectConsole(product.id)} className="red-btn">
                                Спробувати
                            </button>
                        </div>
                    ))}
                </div>
            </div>
        </motion.div>
    );
};

export default Products;
